module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": _vm.args.pass
    }
  }, [(!_vm.args.pass) ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The vote failed")]) : _vm._e(), _c('government', {
    attrs: {
      "government": _vm.args
    }
  }), _c('player-list', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(ref) {
        var player = ref.player;

        return [(_vm.getVote(player)) ? _c('v-icon', {
          staticClass: "icon green--text",
          attrs: {
            "medium": ""
          }
        }, [_vm._v("thumb_up")]) : _c('v-icon', {
          staticClass: "icon red--text",
          attrs: {
            "medium": ""
          }
        }, [_vm._v("thumb_down")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-725743da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/vote/details.vue
// module id = 338
// module chunks = 0